import { motion } from "framer-motion"
import classnames from 'classnames/bind'
import * as styles from './index.module.css'


const cx = classnames.bind(styles)

export default function FormContent({ isLoading, noRadius, fullscreen, children, noStyle }) {
  return (
    <motion.div layout transition={{duration:.18}} className={noStyle ? null : cx(styles.wrapper, { isLoading, fullscreen, noRadius })}>
      {children}
    </motion.div>
  )
}
